
	frappe.templates['resource_event'] = `<div class="resource-event--main">
    <strong>{{ event.title }}</strong>

    {% if (doc?.description) { %}
    {{ doc.description }}
    {% } %}
</div>
`;
